<template>
  <div>
    <van-nav-bar
      title="账户详情"
      left-arrow
      @click-left="$router.push('capital_account?activeTab=2')"
    />
    <!-- <van-overlay :show="loadingMask">
      <div class="wrapper">
        <div class="block">
          <van-loading color="#ee0a24" />
        </div>
      </div>
    </van-overlay> -->
    <CommonLoading ref="commonLoader"></CommonLoading>
    <div style="padding: 15px 15px 50px 15px; font-size: 14px;">
      <van-row>
        <van-col span="16"
          ><span>{{ name }} ({{ order }})</span></van-col
        >
        <van-col span="8" style="text-align: right"
          ><span style="color: #1989fa" @click="getstrategyInfo()">点击更新</span></van-col
        >
      </van-row>
      <van-row style="border-bottom: 1px solid #dcdee0; padding-bottom: 10px">
        <van-col span="24" style="font-size: 13px; padding-top: 5px"
          ><span>{{ time }}</span></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px">
        <van-col span="24"><span>当前总资产(元)</span></van-col>
      </van-row>
      <van-row>
        <van-col span="24" style="font-size: 13px"
          ><span>{{ total }}</span></van-col
        >
      </van-row>
      <van-row class="rowDesign" style="border-bottom: 1px solid #dcdee0">
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>持仓市值(元)</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ market }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>持仓比例</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ depot_ratio }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign" style="background: none">
          <van-row class="topValue" style="font-size: 14px"
            ><span>可用额度(元)</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ available }}</span>
          </van-row>
        </van-col>
      </van-row>
      <van-row style="padding-top: 10px">
        <van-col span="24"><span>当前盈亏(元)</span></van-col>
      </van-row>
      <van-row>
        <van-col span="24" style="font-size: 13px"
          ><span v-bind:class="[profit_loss >= 0 ? 'redText' : 'greenText']">{{
            profit_loss
          }}</span
          ><span
            v-bind:class="[ratioValue >= 0 ? 'redText' : 'greenText']"
            style="padding-left: 10px"
            >{{ ratio }}</span
          ></van-col
        >
      </van-row>
      <van-row style="text-align: center; padding-top: 20px">
        <van-col span="24">
          <img src="../assets/images/capital_meter.png" />
        </van-col>
      </van-row>
      <van-row
        style="
          text-align: center;
          border-bottom: 1px solid #dcdee0;
          padding-bottom: 10px;
        "
      >
        <van-col span="12"
          ><span style="color: #ff2c27">亏损警戒线 (亏损比)<br>{{ warning }} ({{ warning_line_ratio }})</span></van-col
        >
        <van-col span="12"
          ><span style="color: #8bc34a">亏损平仓线 （亏损比）<br>{{ close }} ({{ close_line_ratio }})</span></van-col
        >
      </van-row>
      <van-row class="rowDesign">
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>总配资资金</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ capital_total }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>申请额度</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ apply_quota }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign" style="background: none">
          <van-row class="topValue" style="font-size: 14px"
            ><span>风险保证金</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ bond }}</span>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="rowDesign">
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>收益分成</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ divided }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign">
          <van-row class="topValue" style="font-size: 14px"
            ><span>亏损警戒线</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ warning }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign" style="background: none">
          <van-row class="topValue" style="font-size: 14px"
            ><span>亏损平仓线</span>
          </van-row>
          <van-row style="font-size: 13px" class="topValue"
            ><span style="color: #000000">{{ close }}</span>
          </van-row>
        </van-col>
      </van-row>
      <van-row style="border-bottom: 1px solid #dcdee0; padding: 10px 0px">
        <van-col span="12"><span>账户管理费</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ manage }}</span></van-col
        >
      </van-row>
      <van-row style="padding: 10px 0px">
        <van-col span="12"><span>已操盘天数</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ day }}</span></van-col
        >
      </van-row>
    </div>
    <div class="optionList" id="bottomRow">
      <van-row style="padding: 10px 0px; text-align: center">
        <!-- add popover -->
        <van-col span="6" id="popOverStyle" style="color: #ee0d25"
          ><van-popover
            v-model="showPopover"
            trigger="click"
            :actions="actions"
            @select="onSelect"
            placement="top"
          >
            <template #reference>
              <span>更多操作</span>
            </template>
          </van-popover>
        </van-col>
        <!-- end popover -->

        <van-col span="6" style="color: #ee0d25" @click="closeCapitalAccount"
          ><span>申请结算</span></van-col
        >
        <router-link to="/capital_fund_details"
          ><van-col span="6" style="color: #ee0d25"
            ><span>资金明细</span></van-col
          ></router-link
        >
        <van-col
          span="6"
          style="background: #ee0d25; color: #ffffff"
          @click="
            $store.commit('setSelectedCid', cid);
            direction_capital == 0 ? $router.push({ name: 'Trading', params: {} }) : $router.push({ name: 'TradingDirection', params: { direction: 1 } });
          "
          ><span>交易委托</span></van-col
        >
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";
Vue.use(Dialog);
import CommonLoading from "./CommonLoading";
export default {
  name: "AccountDetails",
  components: {
    CommonLoading,
  },
  data() {
    return {
      close_line_ratio:"0.00",
      warning_line_ratio:"0.00",
      name: "",
      order: "",
      type: "", //策略类型  1天配 2月配
      time: "",
      total: "0.00",
      market: "0.00",
      depot_ratio: "",
      available: "0.00",
      profit_loss: "0.00",
      ratio: "0.00",
      ratioValue: "0.00",
      warning: "0.00",
      close: "0.00",
      capital_total: "0.00",
      apply_quota: "0.00",
      bond: "0.00",
      divided: "0.00",
      manage: "0.00",
      day: "0.00",
      text: "交易日", //交易日 或者交易月
      list: [],
      extractProfit: "0.00", //利润提取 盈亏
      extractMax: "0.00", //最大提取金额
      extractMoney: "", //提取输入金额
      balance: "0.00", //余额
      minAdd: "0.00", //最低追加策略金额
      addMoney: "", //追加策略金额
      minBondAdd: "", //最低追保证金金额
      addBondMoney: "", //追加保证金 金额
      cid: 0,
      direction_capital:0,

      showPopover: false, // for popove
      actions: [
        { text: "追加配资", value: "1" },
        { text: "追加保证金", value: "2" },
      ], // for popover options
      loadingMask: false,
    };
  },
  computed: {},
  methods: {
    getstrategyInfo() {
      let that = this;
      // that.loadingMask = true;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "current_detailed",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var info = res.data.data;
            that.name = info.name;
            that.order = info.order;
            that.type = info.type;
            that.time = info.time;
            that.total = info.total;
            that.market = info.market;
            that.depot_ratio = info.depot_ratio;
            that.available = info.available;
            that.profit_loss = info.profit_loss;
            that.ratio = info.ratio;
            that.ratioValue = that.ratio.replace(/['%]+/g, "");
            that.warning = info.warning;
            that.close = info.close;
            that.capital_total = info.capital_total;
            that.apply_quota = info.apply_quota;
            that.bond = info.bond;
            that.divided = info.divided;
            that.manage = info.manage;
            that.day = info.day;
            that.cid = info.cid;
            that.warning_line_ratio = info.warning_line_ratio;
            that.close_line_ratio = info.close_line_ratio;
            that.direction_capital = info.direction_capital;
            if (that.type == 2) {
              that.text = "交易月";
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          // that.loadingMask = false;
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },

    //  popover function
    onSelect(action) {
      if (action.value == 1) {
        this.$router.push({
          name: "IncreaseCapitalInfo",
          params: { total: this.total, order: this.order },
        });
      } else if (action.value == 2) {
        this.$router.push({
          name: "IncreaseBondInfo",
          params: { total: this.total, order: this.order },
        });
      }
    },

    closeCapitalAccount() {
      Dialog.confirm({
        title: "申请结算",
        message: "您是否确定结算该合约?",
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      })
        .then(() => {
          // on confirm
          this.operationSettlement();
        })
        .catch(() => {
          // on cancel
        });
    },
    //申请结算 - 操作
    operationSettlement() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "settlement",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
              type: "success",
              duration: 1000,
            });
            that.$router.push({
              path: "capital_account?activeTab=2",
            });
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
  mounted: function () {
    this.getstrategyInfo();
  },
};
</script>

<style scoped>

@media only screen and (min-height: 812px) {
  #bottomRow {
    padding-bottom: 25px !important;
  }
}
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 5px;
}

.columnDesign {
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  background: url(../assets/images/line.png) right no-repeat;
  background-size: 1px 35px;
}

.topValue {
  text-align: center;
  line-height: 10px;
  padding-top: 14px;
}

.tableheading {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  padding-bottom: 14px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 14px;
  color: #ff3334;
}

.tablecontent {
  font-size: 14px;
  height: 40px;
  line-height: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 8px;
}

.optionList {
  text-align: center;
  position: fixed;
  bottom: 90px;
  width: 100%;
  height: 60px;
  line-height: 40px;
  background: #ffffff;
  font-size: 14px;
}
</style>

 <style>
#popOverStyle .van-popover--light {
  left: 10px;
  color: #ebedf0;
}

#popOverStyle .van-popover__action {
  width: 100px;
  padding: 0 12px;
  color: #ea811a;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #8bc34a;
}
</style>




// WEBPACK FOOTER //
// src/components/AccountDetails.vue